export const GET_COLLECTIONS = "GET_COLLECTIONS";
export const GET_ALL_TOPICS = "GET_ALL_TOPICS";

export const GET_QUESTION = "GET_QUESTION";
export const CHOOSE_ANSWER = "CHOOSE_ANSWER";

export const SET_RESULT_INFO = "SET_RESULT";
export const GET_RESULT_INFO = "GET_RESULT";
